import * as React from 'react';

import { groupBy } from 'lodash';

import { Text } from '@notino/react-styleguide';

import { ICharacteristic } from '@containers/ProductListing/model';
import { styled } from '@linaria/react';

import { CharacteristicsTable } from '../styled';

import { Characteristic } from './Characteristic';
import { CharacteristicsTableWrapper } from './styled';

const Wrapper = styled.div`
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const AllParametersContent = ({
  characteristics,
}: {
  characteristics: ICharacteristic[];
}) => {
  const groups = groupBy(characteristics, (item) => item.group || '');

  return (
    <Wrapper>
      {Object.entries(groups).map(([group, items]) => (
        <div key={group}>
          <Text typography="labelRegular" marginBottom="12px">
            {group}
          </Text>

          <CharacteristicsTableWrapper noMargin={true}>
            <CharacteristicsTable>
              <tbody>
                {items.map((item) => (
                  <Characteristic
                    key={item.name}
                    item={item}
                    fullWidth={true}
                  />
                ))}
              </tbody>
            </CharacteristicsTable>
          </CharacteristicsTableWrapper>
        </div>
      ))}
    </Wrapper>
  );
};
